module.exports = __webpack_public_path__ + "f211389e1500f21bf8f57fa7dd7c98f8.png";